/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_List_Users_ErrorInputs */

const es_tools_nexata_list_users_error = /** @type {(inputs: Tools_Nexata_List_Users_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al consultar usuarios`)
};

const en_tools_nexata_list_users_error = /** @type {(inputs: Tools_Nexata_List_Users_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error fetching users`)
};

/**
* | output |
* | --- |
* | "Error fetching users" |
*
* @param {Tools_Nexata_List_Users_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_list_users_error = /** @type {((inputs?: Tools_Nexata_List_Users_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_List_Users_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_list_users_error(inputs)
	return en_tools_nexata_list_users_error(inputs)
});
export { tools_nexata_list_users_error as "tools.nexata.list_users_error" }